import { ActionTypes } from './types';

export function setGrids(value: {[key: string]: UserView[]}) {
  return { type: ActionTypes.SET_GRIDS, value };
}

export function addGrids(companyId: string, value: UserView[]) {
  return { type: ActionTypes.ADD_GRIDS, value: { companyId, views: value }}
}